import template from './adpSubnavigation.html';
import controller from './adpSubnavigation.controller';
import './adpSubnavigation.less';

let adpSubnavigationComponent = {
  restrict: 'E',
  bindings: {
    primary: "@",
  },
  transclude: true,
  template,
  controller
};

export default adpSubnavigationComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSubnavigation/adpSubnavigation.component.js